//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'DukeCriteria',
  data() {
    return {
      form:{
        bloodculture:'0',
        endocardial:'0',
        predisp:'0',
        fever:'0',
        vascular:'0',
        immune:'0',
        microbio:'0',
        ards:'0'
      },
      hasScore:false,
      disabled:false,
      "fever_hint": "体温 > 38 °C（100.4 °F）",
      "blood_culture_hint": "2 次独立血培养均发现下述典型的感染性心内膜炎致病菌之一：\n • 草绿色链球菌，或\n • 牛链球菌，或\n • HACEK 菌群，或\n • 社区获得的无原发病灶的金黄色葡萄球菌或肠球菌\n\n感染性心内膜炎致病菌持续血培养阳性（持续性菌血症）定义为：\n • 2 次间隔超过 12 小时的血培养结果阳性，或\n • 3 次独立血培养均阳性或 4 次独立血培养中大多数结果阳性（其中第一次与最后一次采血间隔超过 1 小时）\n • 至少一次阳性血培养结果中检测到贝氏柯克斯体（Coxiella burnetii）或反相 I 型 IgG 抗体滴度 > 1:800",
      "microbio_hint": "血培养阳性但不足以满足主要标准，或感染性心内膜炎致病微生物活动性感染的血清学证据",
      "endocardial_hint": "• 可活动的心内赘生物附着于瓣膜或其支持结构、在返流的路径上、或在植入物表面，或\n• 脓肿，或\n• 新出现的人工瓣膜裂缝或新的瓣膜反流（原有的杂音加重或改变不足以达到标准）",
      "immuno_hint": "• 肾小球肾炎\n• Osler 结节\n• Roth 斑\n• 类风湿因子",
      "vascular_hint": "• 大动脉栓塞\n• 脓毒性肺梗死\n• 霉菌性动脉瘤\n• 颅内出血\n• 结膜出血\n• Janeway 病损",
      "Predisposing_heart_condition_or_intravenous_drug_use": "心脏易患因素或静脉药瘾者",
      major:0,
      minor:0
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let result =  self.major > 1 ? 2 : (self.major > 0 ? (self.minor > 2 ? 2 : (self.minor > 0 ? 1 : 0)) : (self.minor > 4 ? 2 : (self.minor > 2 ? 1 : 0)))
      self.hasScore = true
      console.log(result,11);
      return String(result)

      // major > 1 ? 2 : (major > 0 ? (minor > 2 ? 2 : (minor > 0 ? 1 : 0)) : (minor > 4 ? 2 : (minor > 2 ? 1 : 0)))
    },
    /** 计算主要标准 */
    score1() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.bloodculture + form.endocardial
      self.major = String(result)
      return String(result)
    },
    /** 计算次要标准 */
    score2() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else { 
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.predisp + form.microbio + form.fever + form.immune + form.ards + form.vascular 
      self.minor = String(result)
      return String(result)
    },
  },
  
  
}



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/DukeCriteria.vue